"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _DmsModal = require("../DmsModal/DmsModal");
var _TouchApp = _interopRequireDefault(require("@mui/icons-material/TouchApp"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const DmsAlertPutFinger = _ref => {
  let {
    showModal,
    setShowModal
  } = _ref;
  const [progress, setProgress] = (0, _react.useState)(100);
  (0, _react.useEffect)(() => {
    if (showModal && progress > 0) {
      const timer = setInterval(() => {
        setProgress(prev => {
          if (prev > 1) {
            return prev - 1;
          } else {
            clearInterval(timer);
            setShowModal(false);
            return 0;
          }
        });
      }, 100);
      return () => clearInterval(timer);
    }
  }, [showModal, progress]);
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 2,
    sm: 4,
    md: 4
  }, /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal, {
    isVisible: showModal,
    onClose: () => setShowModal(false),
    closeWithIconOnly: true
  }, /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal.Header, {
    title: _reactIntlUniversal.default.get("WaitingFinger").d("Wating finger"),
    onClose: () => setShowModal(false)
  }), /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement(_TouchApp.default, {
    style: {
      fontSize: '4rem',
      color: '#1976d2'
    }
  })), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "body1",
    align: "center",
    style: {
      marginTop: '2rem'
    }
  }, _reactIntlUniversal.default.get("PlaceYourFinger").d("Place your finger on the scanner"), ".")), /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal.Footer, null, /*#__PURE__*/_react.default.createElement(_material.LinearProgress, {
    variant: "determinate",
    value: progress,
    style: {
      width: '100%',
      marginTop: '1rem',
      height: '8px'
    }
  })))));
};
var _default = exports.default = DmsAlertPutFinger;